// extracted by mini-css-extract-plugin
module.exports = {"container":"nav-list_container__aExn2","item":"nav-list_item__2_03G"};